import React from 'react';
import styles from './Categories.module.css';

const Categories = () => (
  <div className={styles.Categories}>Under construction</div>
);

Categories.propTypes = {};

Categories.defaultProps = {};

export default Categories;
